const Loader = (props) => {
    return (
        <div className={"overlay-part " + (props?.show ? "show-m" : "show-n")} style={{ zIndex: "10" }}>
            <div className={"dataLoadpage " + (props?.show ? "show-m" : "show-n")}></div>
            <div className={"dataLoadpageimg " + (props?.show ? "show-m" : "show-n")}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </div>
    )
}
export default Loader